import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {Formik, FormikHelpers} from 'formik';
import classnames from 'classnames';
import FilterText from '../../../_common/components/FilterText';
import {usePopupPriceCatalogContext} from '../../contexts/PopupPriceCatalogContext';
import {applyFilter} from '../../../../../utils/prepareApplyFilter';
import styles from '../../../_common/styles/filtersBar.module.scss';

type PriceCatalogFilterValues = {
  mainCategory: string;
  secondCategory: string;
  serviceDescription: string;
};

export function PriceCatalogFilters() {
  const {formatMessage} = useIntl();
  const context = usePopupPriceCatalogContext();

  const catalogProps = useMemo(() => {
    return {
      queryParams: context.queryParams,
      setQueryParams: context.setQueryParams,
    };
  }, [context]);

  const prefix = 'filter-placeholder';

  const qs = new URLSearchParams(window.location.search);

  const initialValues: PriceCatalogFilterValues = {
    mainCategory: qs.get('mainCategory') || '',
    secondCategory: qs.get('secondCategory') || '',
    serviceDescription: qs.get('serviceDescription') || '',
  };

  return (
    <Formik<PriceCatalogFilterValues>
      initialValues={initialValues}
      onSubmit={(
        values: PriceCatalogFilterValues,
        _: FormikHelpers<PriceCatalogFilterValues>
      ) => applyFilter(values, catalogProps)}
      enableReinitialize
    >
      {({values, handleSubmit, handleBlur, setFieldValue}) => (
        <form
          onSubmit={handleSubmit}
          className={classnames(styles.container, 'mb-6')}
        >
          <div
            className={classnames(
              styles.filtersContainer,
              'justify-content-start'
            )}
          >
            <FilterText
              fieldName="mainCategory"
              value={values.mainCategory}
              placeholder={formatMessage({
                id: `${prefix}-mainCategory`,
                defaultMessage: 'Main',
              })}
              containerClassnames={styles.filter}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
              handleBlur={handleBlur}
              formatValue={false}
            />
            <FilterText
              fieldName="secondCategory"
              value={values.secondCategory}
              placeholder={formatMessage({
                id: `${prefix}-secondCategory`,
                defaultMessage: 'Second',
              })}
              containerClassnames={styles.filter}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
              handleBlur={handleBlur}
              formatValue={false}
            />
            <FilterText
              fieldName="serviceDescription"
              value={values.serviceDescription}
              placeholder={formatMessage({
                id: `${prefix}-serviceDescription`,
                defaultMessage: 'Description',
              })}
              containerClassnames={styles.filter}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
              handleBlur={handleBlur}
              formatValue={false}
            />
          </div>
        </form>
      )}
    </Formik>
  );
}

export default PriceCatalogFilters;